<template>
    <div class="traceless content-view">
        <el-tabs v-model="moduleName" type="card" @tab-click="handleTabTrigger">
            <el-tab-pane name="shoutao">
                <span slot="label">
                    <img class="menu-type-img" :src="require('@/index/assets/shop_img/淘宝.png')" alt="alt" />
                    <span>淘宝</span>
                </span>

                <div>
                    <h2 class="fs-24 text-center fc-theme">手淘无痕做单</h2>
                    <p class="subtitle text-center fs-14 fc-666"> 用户直接下单不需浏览自己宝贝，安全性较高，不计入访客，转化率会超高，甚至超过100%无搜索权重，只累计基础销量权重。 </p>
                    <div v-if="activeMarking === 'senior'">
                        <top-price code="noTraceSupplementSenior"></top-price>
                    </div>
                    <div v-else>
                        <top-price code="noTraceSupplementOrdinary" :batch="activeMarking == 'batch'"></top-price>
                    </div>

                    <div class="flex marginT-20 paddingL-50">
                        <el-button type="primary" @click="activeMarking = 'senior'" :plain="activeMarking !== 'senior'">标签单高级版</el-button>
                        <el-button type="primary" @click="activeMarking = 'ordinary'" :plain="activeMarking !== 'ordinary'" class="marginL-20">普通版</el-button>
                        <el-button type="primary" @click="activeMarking = 'batch'" :plain="activeMarking !== 'batch'" class="marginL-20">批量做单</el-button>
                    </div>
                    <div class="flex fc-666 marginT-10 paddingL-50">
                        <div v-if="activeMarking === 'ordinary'">生成稳定版二维码需额外增加<span class="fc-theme">1</span>点券</div>
                        <div v-else-if="activeMarking === 'batch'">
                            <div>1、填写商品后请先获取SKU，再点击展开SKU选择指定SKU下单； </div>
                            <template v-if="itemSkuPrice.vip_point && itemSkuPrice.point && itemSkuPrice.vip_point != itemSkuPrice.point">
                                <div>2、每次点击获取SKU成功后额外收取<span class="fc-theme"> {{ itemSkuPrice.vip_point }}(VIP会员)/{{ itemSkuPrice.point }}(非VIP会员) </span>点券；
                                </div>
                            </template>
                            <template v-else>
                                <div>2、每次点击获取SKU成功后额外收取<span class="fc-theme"> {{ itemSkuPrice.point }} </span>点券；</div>
                            </template>
                        </div>
                    </div>

                    <div class="flex">
                        <el-form class="flex-3 marginT-50" :model="form" label-width="100px">
                            <!-- 标签单高级版 -->
                            <div v-if="activeMarking === 'senior'">
                                <el-form-item label="商品链接">
                                    <el-input v-model="form.url" placeholder="请输入商品链接或商品ID"></el-input>
                                </el-form-item>
                                <el-form-item label="数量">
                                    <el-input v-model.number="form.count" type="number" placeholder="请输入数量" max="998" min="1" @blur="form.count && form.count > 998 ? form.count = 998 : null"></el-input>
                                </el-form-item>
                                <el-form-item label="关键词">
                                    <el-input v-model="form.tag" placeholder="请输入关键词"></el-input>
                                </el-form-item>
                                <el-form-item label="旺旺号">
                                    <el-input v-model="form.account" placeholder="请输入旺旺号"></el-input>
                                </el-form-item>
                                <el-form-item>
                                    <el-button type="danger" @click="handleSubmit" :loading="subLoading">生成二维码</el-button>
                                </el-form-item>
                            </div>
                            <!-- 普通版 -->
                            <div v-if="activeMarking === 'ordinary'">
                                <el-form-item label="商品链接">
                                    <el-input v-model="form.url" placeholder="请输入商品链接或商品ID"></el-input>
                                </el-form-item>
                                <el-form-item label="数量">
                                    <el-input type="number" v-model.number="form.count" placeholder="请输入数量" max="998" min="1" @blur="form.count && form.count > 998 ? form.count = 998 : null"></el-input>
                                </el-form-item>
                                <el-form-item>
                                    <el-button type="danger" @click="handleSubmit" :loading="subLoading">生成二维码</el-button>
                                    <el-button type="danger" class="bg-none" @click="handleSubmit('stable')" :loading="subLoading" plain>生成稳定版二维码</el-button>
                                </el-form-item>
                            </div>

                            <!-- 批量做单 -->
                            <div v-show="activeMarking === 'batch'">
                                <div v-for="(batch_item, idx) in batch_data" :key="idx" class="batch-trace">
                                    <el-row>
                                        <el-col :span="15">
                                            <div>商品链接 [{{ idx+1 }}]</div>
                                            <el-input v-model="batch_item.link" type="text" placeholder="请输入商品id或链接" @change="batchLinkChanged(idx)"></el-input>
                                            <template v-for="(batch_item_sku) in batch_item.skus">
                                                <div v-if="batch_item_sku.selected" style="margin-top: 3px; padding: 2px; background: #ff6464; font-size: 0.75rem; color: #fff;">
                                                    <div>
                                                        <span style="font-weight: bold;">选中：</span>{{ batch_item_sku.name }}
                                                    </div>
                                                    <div>
                                                        <span style="font-weight: bold;">总价：</span>{{ (parseFloat(batch_item_sku.price)*batch_item.quantity).toFixed(2) }}
                                                    </div>
                                                </div>
                                            </template>
                                        </el-col>

                                        <el-col :offset="1" :span="3">
                                            <div>数量</div>
                                            <el-input-number v-model="batch_item.quantity" :min="1"></el-input-number>
                                        </el-col>
                                    </el-row>

                                    <el-row class="row-opt">
                                        <el-col :span="12">
                                            <el-button size="small" :loading="batch_item.loading" :disabled="!batch_item.link || batch_item.sku > -1" 
                                                type="primary" @click="getSKU(idx)">获取SKU</el-button>

                                            <el-popover
                                                style="margin-left: 10px;"
                                                placement="right"
                                                v-model="batch_item.pop_visible">
                                                <el-table :data="batch_item.skus" max-height="280" stripe>
                                                    <el-table-column width="250" label="图片">
                                                        <template slot-scope="scope">
                                                            <div>{{ scope.row.name }}</div>
                                                            <img v-if="scope.row.images.length > 0" :src="scope.row.images[0]" style="width: 28px" />
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column width="90" property="price" label="价格"></el-table-column>
                                                    <el-table-column width="90" label="操作">
                                                        <template slot-scope="scope">
                                                            <el-button
                                                            size="small"
                                                            :type="scope.row.selected ? 'danger' : 'success'"
                                                            @click="pickSKU(idx, scope.row.sku_id)">{{ scope.row.selected ? '已选' : '选择' }}</el-button>
                                                        </template>
                                                    </el-table-column>

                                                    <div slot="append" class="batch-item-custom-sku">
                                                        <div class="tip">SKU有问题？</div>
                                                        <el-button @click="showCustomSKUDialog(idx)" type="primary">手动输入skuID</el-button>
                                                    </div>

                                                </el-table>
                                                <el-button size="small" slot="reference" :disabled="batch_item.sku < 0" type="primary" 
                                                    :icon="batch_item.pop_visible ? 'el-icon-caret-top' : 'el-icon-caret-bottom'">展开SKU</el-button>
                                            </el-popover>
                                        </el-col>

                                        <el-col :offset="4" :span="8">
                                            <el-button title="增加一个商品" @click="addBatchItem" v-if="idx == 0 && batch_data.length < 10" type="success" icon="el-icon-plus" circle></el-button>
                                            <el-button title="删除当前商品" @click="delBatchItem(idx)" v-if="idx > 0" type="danger" icon="el-icon-delete" circle></el-button>
                                        </el-col>
                                    </el-row>

                                    <el-divider v-if="idx < batch_data.length - 1"></el-divider>
                                </div>

                                <el-form-item style="margin-top: 2rem;">
                                    <el-button type="danger" @click="handleSubmit" :loading="subLoading">生成二维码</el-button>
                                </el-form-item>
                            </div>

                            <el-form-item v-show="showQrResult">
                                <div class="qrcode marginT-20 flex flex-center" ref="qrcode" id="qrcode"></div>
                            </el-form-item>
                        </el-form>
                        <!-- tips info -->
                        <div class="flex-2 marginL-20">
                            <el-card class="box-card tip-card">
                                <div slot="header" class="clearfix">
                                    <el-tabs v-model="activeName">
                                        <el-tab-pane label="功能介绍" name="功能介绍"></el-tab-pane>
                                        <el-tab-pane label="常见问题" name="常见问题"></el-tab-pane>
                                        <el-tab-pane label="使用场景" name="使用场景"></el-tab-pane>
                                    </el-tabs>
                                </div>
                                <div v-if="activeName === '功能介绍'">
                                    <div class="title marginT-10 fc-theme fs-18">功能介绍</div>
                                    <div v-if="activeMarking === 'senior'" class="content fs-14 fc-666">
                                        无痕做单标签单高级版是在基础版上面增加了指定搜索词的权重，不仅仅能增加商品的基础销量权重还增加了搜索词的权重<br>
                                        但是使用标签单高级版一定要控制做单的数量，不可以过多依靠无痕做单标签单高级版，对于新品建议还是选择基础版会更加安全<br>
                                        使用高级无痕做单标签单高级版生意参谋后台数据会显示成交关键词（设置的搜索词），成交来源显示手淘搜索，会有搜索词的权重和基础销量权重。
                                    </div>
                                    <div v-else class="content fs-14 fc-666">
                                        无痕做单就是显示成交关键词，但是成交来源里面什么都不显示，没有任何痕迹，快速带动关键词搜索权重，获得更多展现；<br>
                                        对于店铺新品破零或者只是增加商品的基础销量权重，无痕下单直接越过浏览过程，直接下单；<br>
                                        生意参谋后台数据只显示成交关键词，成交来源里面什么都不显示，没有任何痕迹，这样可以快速带动关键词搜索权重，引爆店铺流量；<br>
                                        生成稳定版二维码，可以快速获得卡首屏二维码，不会出现并发导致使用报错。
                                    </div>
                                    <div class="title marginT-10 fc-theme fs-18">消费说明</div>
                                    <div class="content fs-14 fc-666">
                                        1、无痕做单普通版本：非会员{{pricePreMonth['ordinary'].point}}点券/个，会员{{pricePreMonth['ordinary'].vip_point}}点券/个，点击<span class="fc-blue point" @click="$router.push('/vip')">开通会员</span>；<br>
                                        2、无痕做单标签单高级版本：非会员{{pricePreMonth['senior'].point}}点券/个，会员{{pricePreMonth['senior'].vip_point}}点券/个，点击<span class="fc-blue point" @click="$router.push('/vip')">开通会员</span>；<br>
                                        3、搜索词扣一次费用。查询成功才会扣取点券，查询失败不扣取点券；<br>
                                        4、接口合作请加微信{{getkfWx()}}
                                    </div>
                                </div>
                                <div v-if="activeName === '常见问题'">
                                    <div class="title marginT-10 fc-theme fs-18">常见问题</div>
                                    <div v-if="activeMarking === 'senior'" class="content fs-14 fc-666">
                                        1、只能指定的旺旺去下单吗？其他旺旺号去下单可以吗？<br>
                                        标签单高级版只有设置的旺旺号去下单才可以增加指定的搜索词权重和基础权重，如果想其他旺旺号下单需要重新设置；<br>
                                        2、店铺近期被处罚或者商品降权后，使用无痕做单功能有效果吗？<br>
                                        通常商品已经降权或者被处罚了，这个时候不可以大量的进行做单，需要适量的下单，通过无痕做单可以快速增加基础权重；
                                    </div>
                                    <div v-else class="content fs-14 fc-666">
                                        1、为什么订单成交后商品权重没有像自然下单那样增加？<br>
                                        因为淘宝系统无法查找这单的轨迹，自然也不会给予权重的，只计基础销量权重<br>
                                        2、无痕做单对补手的要求是什么？<br>
                                        补手标签和店铺人群标签相符，所以这就需要店铺人群标签比较精准<br>
                                        3、无痕做单安全吗？<br>
                                        无痕做单就是做单没有留下任何购买行为的痕迹，系统无从稽查起，做单非常安全
                                    </div>
                                </div>
                                <div v-if="activeName === '使用场景'">
                                    <div class="title marginT-10 fc-theme fs-18">使用场景</div>
                                    <div v-if="activeMarking === 'senior'" class="content fs-14 fc-666">
                                        1、店铺近期被处罚或者是商品已经被降权，需要将商品的基础权重增加上去，将商品的权重稳住；<br>
                                        2、标签单高级版是针对有一定销量的商品，增加指定搜索词的权重值，不仅仅只是增加基础权重。
                                    </div>
                                    <div class="content fs-14 fc-666">
                                        1、对于店铺新品快速提升础销量权重，无痕做单就是直接越过浏览过程，直接下单，没有任何痕迹对应新品做单更加安全；<br>
                                        2、对于近期店铺需要谨慎做单使用无痕下单安全性更高，每天一两百单内非常安全，（让用户直接下单不要浏览自己的宝贝，这样会非常安全）不计入访客，转化率会超高，甚至超过100%无搜索权重，只累计基础销量权重。<br>
                                        3、无痕下单的作用是为了增加权重获取更多流量，是为了做店铺运营，将流量转化为订单；<br>
                                        4、具体的无痕做单就是直接越过浏览过程，直接下单，没有任何痕迹，即使通过生意参谋流量路径，访客人数等数据都无法显示，这样可以快速带动关键词搜索权重，引爆店铺流量；<br>
                                        5、新品上架，帮助店铺商品快速破零，获得更多的流量和曝光
                                    </div>
                                </div>
                            </el-card>
                        </div>
                    </div>

                    <!-- record -->
                    <el-card class="box-card">
                        <div slot="header" class="relative">
                            <span class="fw-bold fc-333">手淘无痕做单生成记录</span>
                        </div>
                        <el-table :data="tableData" border>
                            <el-table-column prop="result_data.invoke_service" label="版本类型"></el-table-column>
                            <el-table-column prop="result_data.product_id" label="商品ID"></el-table-column>
                            <el-table-column prop="result_data.product_title" label="商品标题"></el-table-column>
                            <el-table-column prop="result_data.sku_name" label="规格"></el-table-column>
                            <el-table-column prop="result_data.account" label="旺旺号"></el-table-column>
                            <el-table-column prop="result_data.tag" label="关键词"></el-table-column>
                            <el-table-column prop="" label="状态">
                                <template slot-scope="scope"><span>成功</span></template>
                            </el-table-column>
                            <el-table-column prop="" label="二维码">
                                <template slot-scope="scope">
                                    <el-button type="primary" size="mini" @click="lookQrCode(scope.row)">查看</el-button>
                                </template>
                            </el-table-column>
                            <el-table-column prop="created_at" label="创建时间">
                                <template slot-scope="scope">{{ (scope.row.created_at * 1000) | dateFormatUtils}}</template>
                            </el-table-column>
                        </el-table>
                        <div class="pages marginT-20 text-center">
                            <el-pagination @current-change="handleCurrentChange" :current-page="page" :page-size="5" layout="total, prev, pager, next, jumper" :total="total"></el-pagination>
                        </div>
                    </el-card>

                    <shop-info-dialog v-if="shopInfoDialog.show" v-model="shopInfoDialog.show" :ex-data="shopInfoDialog.exData" @success="qrSuccess"></shop-info-dialog>
                    <qr-code-dialog v-if="qrCodeDialog.show" v-model="qrCodeDialog.show" :ex-data="qrCodeDialog.exData"></qr-code-dialog>
                </div>

                <el-dialog title="系统提示" :visible.sync="dialogSKUVisible" width="40%">
                    <div class="dialog_sku_tips">该商品未能获取到正确的SKU，请根据实际情况选择</div>

                    <el-form status-icon :rules="skuFormRule" ref="skuForm" :model="skuForm" label-width="150px">
                        <el-form-item label="该商品是否有SKU" prop="hasSKU">
                            <el-radio-group v-model="skuForm.hasSKU">
                                <el-radio :label="0"> 否</el-radio>
                                <el-radio :label="1"> 是</el-radio>
                            </el-radio-group>
                        </el-form-item>

                        <el-form-item v-show="skuForm.hasSKU == 1" label="请输入商品SKUID" prop="customSKU">
                            <el-input v-model="skuForm.customSKU" placeholder="请输入SKUID，下单规格的id"></el-input>

                            <div>
                                <ul class="custom_sku_tips">
                                    <li>1. 只能填写一个下单SKUID；</li>
                                    <li>2. SKUID获取可通过PC端商品详情点击规格在URL中显示 的ID，或者通过商品管理中复制SKUID；</li>
                                </ul>
                            </div>
                        </el-form-item>

                        <el-form-item>
                            <el-button type="primary" @click="submitCustomSKUForm('skuForm')">确认</el-button>
                            <el-button type="info" @click="quitSKUForm('skuForm')">取消</el-button>
                        </el-form-item>
                    </el-form>
                </el-dialog>
            </el-tab-pane>

            <el-tab-pane name="pdd">
                <span slot="label">
                    <img class="menu-type-img" :src="require('@/index/assets/shop_img/拼多多.png')" alt="alt" />
                    <span>拼多多</span>
                </span>
            </el-tab-pane>

            <el-tab-pane name="1688">
                <span slot="label">
                    <img class="menu-type-img" :src="require('@/index/assets/shop_img/1688.png')" alt="alt" />
                    <span>1688</span>
                </span>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
import QRCode from 'qrcodejs2'
import mixin from '@/index/mixin/pagination'
import { mapState } from 'vuex'
import ShopInfoDialog from "./_dialog/ShopInfoDialog"
import QrCodeDialog from "./_dialog/QrCodeDialog"
export default {
    mixins: [mixin],
    components: {
        ShopInfoDialog,
        QrCodeDialog,
    },
    computed: mapState(['userData', 'configData']),
    data() {
        var validateCustomSKU = (rule, value, callback) => {
            if (this.skuForm.hasSKU == 1 && value === '') {
                callback(new Error('请输入SKU'));
            } else {
                callback();
            }
        };

        return {
            customSKUIdx: -1,
            skuFormRule: {
                customSKU: [{ validator: validateCustomSKU, trigger: 'blur'}]
            },
            dialogSKUVisible: false,
            skuForm: {
                hasSKU: 0,
                customSKU: '',
            },

            itemSkuPrice: {},
            skuLoading: false,
            batch_data: [
                {link:"", quantity:1, sku:-1, skus: [], pop_visible: false, loading: false}
            ],

            moduleName: "shoutao",
            activeMarking: 'ordinary',
            pricePreMonth: {
                'senior': {},
                'ordinary': {},
                'batch': {},
            },
            subLoading: false,
            activeName: '功能介绍',
            activeNamePdd: '功能介绍',
            showQrResult: false,
            showQrResultPdd: false,
            form: {
                product_id: '',
                sku_id: '',
                sku_name: '',
                product_title: '',
                count: 1,
                tag: '',
                account: ''
            },
            formPdd: {
                goods_id: '',
                sku_id: '',
                count: 1,
            },
            tableData: [],
            tableDataPdd: [],
            searchForm: {
                invokeName: 'noTraceSupplementSenior',
                psize: 5,
            },
            tableUrl: '/tool/accounts/invoke-log',
            shopInfoDialog: {
                show: false,
                exData: true,
            },
            qrCodeDialog: {
                show: false,
                exData: true,
            },
            qrCodeDialogPdd: {
                show: false,
                exData: true,
            },
            log_id: null, // 获取详情后的 log_id 最后生成二维码的时候需要传递
        }
    },
    methods: {
        quitSKUForm(formName){
            this.dialogSKUVisible = true;
            this.$nextTick(()=>{
                this.$refs[formName].resetFields();
            })
            
            this.dialogSKUVisible = false;
            this.customSKUIdx = -1;
        },
        submitCustomSKUForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    if (this.customSKUIdx != -1 && this.batch_data[this.customSKUIdx]) {
                        let customSkuID = this.skuForm.hasSKU == 0 ? 0 : this.skuForm.customSKU;
                        if (this.activeMarking == 'batch') {
                            this.batch_data[this.customSKUIdx]['sku'] = customSkuID;
                            this.handleSubmit()
                        } else {
                            this.customSeniorTraceless(customSkuID)
                        }

                        this.quitSKUForm(formName)
                    } else {
                        this.$alert('提交有误，请刷新页面重试', '系统提示', {
                            confirmButtonText: '确定',
                            type: 'warning'
                        });
                    }
                } else {
                    return false;
                }
            });
        },
        batchLinkChanged(idx) {
            this.batch_data[idx]['sku'] = -1
            this.batch_data[idx]['skus'] = []
            this.batch_data[idx]['pop_visible'] = false
            this.batch_data[idx]['loading'] = false
        },
        pickSKU(idx, sku_id) {
            this.batch_data.forEach((item, i) => {
                if (idx == i) {
                    item.pop_visible = false
                    item.sku = sku_id
                    item.skus.forEach((skuItem) => {
                        skuItem.selected = sku_id == skuItem.sku_id
                    })
                }
            })
        },
        async getSKU(idx) {
            // 调用接口
            let batchItem = this.batch_data[idx]
            if (batchItem && batchItem.link){
                this.batch_data[idx].loading = true

                const data = await this.$fetch("/api/proxy/web/tbitemsku", {url: batchItem.link}, 'post')

                this.batch_data[idx]['skus'] = data.data
                this.batch_data[idx]['sku'] = data.data.length > 0 ? data.data[0]['sku_id'] : -1

                this.batch_data[idx].loading = false

                if (data.data && data.data.length == 0) {
                    this.showCustomSKUDialog(idx);
                }
            }
        },
        showCustomSKUDialog(idx) {
            this.quitSKUForm('skuForm')
            this.customSKUIdx = idx;
            this.dialogSKUVisible = true;
            return false
        },
        delBatchItem(idx){
            this.batch_data.splice(idx, 1)
        },
        addBatchItem(){
            this.batch_data.push({link:"", quantity:1, sku:-1, skus: [], pop_visible: false, loading: false})
        },
        handleTabTrigger(tab, event) {
            if (tab.name === 'pdd') {
                this.$router.push('/traceless/pdd')
            } else if (tab.name === '1688'){
                this.$router.push('/traceless/1688')
            } else {
                this.$router.push('/traceless')
            }
        },
        lookQrCode(row) {
            window.showQrCode(row.result_data.item_url);
        },
        async customSeniorTraceless(sku_id){
            this.subLoading = true
            let url = this.activeMarking === 'senior' ? '/tool/accounts/no-trace-supplement-senior-web' : '/tool/accounts/no-trace-supplement-ordinary-web'
            const staForm = this.isStable === 'stable' ? {stable: 1} : {}
            const data = await this.$fetch(url, {
                ...staForm,
                count: this.form.count,
                tag: this.form.tag,
                account: this.form.account,
                product_id: this.form.product_id,
                sku_id: sku_id,
                log_id: this.log_id,
                product_title: '',
                sku_name: '',
            }, 'post')
            this.subLoading = false
            if (+data.code === 0) {
                this.qrCodeDialog.exData = {
                    url: data.data.url
                }
                this.qrCodeDialog.show = true;

                await this.init()
            }
        },
        async handleSubmit(isStable) {
            // 批量做单
            if (this.activeMarking === 'batch') {
                await this.handleSubmitBatch();
                return false;
            }

            if (!this.form.url || !this.form.count) {
                this.$message.error("请填写完整")
                return
            }

            // 标签单高级版
            if (this.activeMarking === 'senior') {
                if (!this.form.tag || !this.form.account) {
                    this.$message.error('请填写完整')
                    return
                }
            }

            let shopInfo = await this.getShopInfo(isStable);

            // 不存在 shopInfo 说明获取 shopInfo 失败, 函数内会处理错误提示
            if (!shopInfo) {
                return
            }

            // 如果没有 sku 则直接生成二维码
            if (!shopInfo.skus || !shopInfo.skus.length) {
                this.form.sku_id = "";
                this.form.product_title = shopInfo.title;
                this.form.sku_name = "";

                this.subLoading = true
                let url = this.activeMarking === 'senior' ? '/tool/accounts/no-trace-supplement-senior-web' : '/tool/accounts/no-trace-supplement-ordinary-web'
                const staForm = isStable === 'stable' ? {stable: 1} : {}
                const data = await this.$fetch(url, {
                    ...this.form,
                    ...staForm,
                    log_id: this.log_id,
                }, 'post')
                this.subLoading = false
                if (+data.code === 0) {
                    this.qrCodeDialog.exData = {
                        url: data.data.url
                    }
                    this.qrCodeDialog.show = true;

                    await this.init()
                }

                return
            }

            this.shopInfoDialog.exData = {
                shopInfo,
                count: this.form.count,
                tag: this.form.tag,
                account: this.form.account,
                product_id: this.form.product_id,
                activeMarking: this.activeMarking,
                isStable,
                log_id: this.log_id,
            }
            this.shopInfoDialog.show = true;
        },

        // 批量做单
        async handleSubmitBatch() {
            this.$confirm(`请确定填写无误，是否开始生成二维码？`, '确认', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
            }).then(async () => {
                let batchData = this.batch_data;

                if (batchData.length > 10) {
                    this.$message.error('最多输入10个链接');
                    return false;
                }

                let errTest = '';
                let newBatchData = [];
                
                let forIndex = 1;
                for (let ele of batchData){
                    let link = ele.link;

                    if (link.includes('http')) {
                        ele.link = this.param2Obj(link).id;
                    } 

                    if (ele.link == null || ele.link.trim() === '') {
                        errTest = `第${forIndex}个链接不能为空, 请重新填写`;
                        break;
                    }
                    
                    const reg = /^[0-9]*$/;
                    if (!reg.test(ele.link)) {
                        errTest = `第${forIndex}个链接有错误, 请重新填写`;
                        break;
                    }

                    if (ele.sku < 0) {
                        errTest = `第${forIndex}个链接没有选择SKU, 请选择`;
                        break;
                    }

                    if (ele.quantity < 1) {
                        errTest = `第${forIndex}个链接购买数量有误，请重新填写`;
                        break;
                    }

                    newBatchData.push({
                        'link': ele.link,
                        'quantity': ele.quantity,
                        'sku': ele.sku,
                    })

                    forIndex++;
                }

                if (newBatchData.length != batchData.length || errTest) {
                    errTest = errTest ? errTest : '表单填写有误'
                    this.$alert(errTest, '系统提示', {
                        confirmButtonText: '确定',
                        type: 'error'
                    });
                    return false;
                }

                this.subLoading = true
                let url = '/api/proxy/web/noTraceSupplementOrdinary';
                const data = await this.$fetch(url, {list: newBatchData}, 'post')
                this.subLoading = false
                if (+data.code === 0) {
                    this.showQrResult = true
                    this.qrcode(data.data.url)
                    await this.init()
                }
            })
        },

        // 根据商品链接获取商品信息
        async getShopInfo(isStable) {
            if (!this.form.url || this.form.url.replace(/ /g, '').length === 0) {
                this.$message.error("请输入正确的商品链接")
                return
            }

            // 处理 shopId TODO: 这里的 param2Obj 和 批量做单的 param2Obj 应该 try 一个错误处理比较好, 暂时没空做, 有机会写一个
            let shopId = "";
            if (this.form.url.indexOf("http") > -1) {
                shopId = this.param2Obj(this.form.url).id
            } else {
                const reg = /^[0-9]*$/;
                if (!reg.test(this.form.url)) {
                    this.$message.error('请正确填写商品链接')
                    return
                }
                shopId = this.form.url
            }

            this.form.product_id = shopId
            let shopInfo = null;

            this.subLoading = true
            try {
                shopInfo = await this.getPdaTao(shopId, isStable)
                return shopInfo;
            } catch (error) {
                console.log({error})
            } finally {
                this.subLoading = false
            }
        },

        async getPdaTao(shopId, isStable) {
            let url = ""
            let uploadData = {};
            if (this.activeMarking === "senior") {
                window.checkDiscountPackage("noTraceSupplementSenior")
                // 标签单高级版
                url = "/api/proxy/web/noTraceSupplementSenior"
                uploadData = {
                    product_url: shopId,
                    count: this.form.count,
                    tag: this.form.tag,
                    account: this.form.account,
                }
            } else {
                window.checkDiscountPackage("noTraceSupplementOrdinary")
                if (isStable === 'stable' ) {
                    // 普通版稳定版
                    url = "/api/proxy/web/noTraceSupplementOrdinaryV1"
                } else {
                    // 普通版
                    url = "/api/proxy/web/noTraceSupplementOrdinary"
                }

                uploadData = {
                    product_url: shopId,
                    count: this.form.count,
                }
            }

            const res = await this.$fetch(url, uploadData, 'post')

            if (res.code === 0) {
                if (res.data && res.data.result_message && (res.data.result_message === "商品不存在" || res.data.result_message === "商品不存在或已下架")) {
                    this.log_id = res.data.log_id;
                    this.showCustomSKUDialog(0);
                } else if (res.msg === "商品不存在测试已超过10次，已限制当天不可用，请明天再来！") {
                    this.$alert('商品不存在测试已超过10次，已限制当天不可用，请明天再来！', '提示', {
                        confirmButtonText: '确定',
                        callback: action => {
                        }
                    }).then(r => console.log({r}));
                } else {
                    this.log_id = res.data.log_id;
                    return this.parseData(res.data.result_data)
                }
            }
            return null
        },

        parseData(allShopInfo) {
            let baseData = {
                title: '',
                thumb: [],
                skus: []
            }
            if (allShopInfo.sku_info && !allShopInfo.skuBase) {
                allShopInfo.skuBase = allShopInfo.sku_info
            }
            if (allShopInfo.skuBase && allShopInfo.skuBase.props && allShopInfo.skuBase.props.length > 0) {
                let skusProps = {}
                allShopInfo.skuBase.props.map(item => {
                    skusProps[item.pid] = item.name
                    if (item.values && item.values.length > 0) {
                        item.values.map(v => {
                            skusProps[v.vid] = v.name
                        })
                    }
                })

                let skus = []
                skus = allShopInfo.skuBase.skus.map(item => {
                    // TODO: 这里的 propPath 还是 prop_path 参数核实好, 淘宝官方和后台接口返回的是否一致
                    let allProps = '';
                    if (item.prop_path) {
                        allProps = item.prop_path.split(';')
                    } else {
                        allProps = item.propPath.split(';')
                    }
                    let skuName = allProps.map(prop => {
                        let skuKeyValue = prop.split(':')
                        return skusProps[skuKeyValue[0]] + ':' + skusProps[skuKeyValue[1]]
                    }).join(';')
                    let skuInfo = {
                        skuId: item.skuId || item.sku_id,
                        skuName
                    }
                    return skuInfo
                })
                baseData.skus = skus
            }

            baseData.title = allShopInfo.item.title
            baseData.thumb = allShopInfo.item.images
            return baseData
        },

        async qrSuccess(url) {
            this.qrCodeDialog.exData = {
                url: url
            }
            this.qrCodeDialog.show = true;

            await this.init()
        },

        async priceLimit(name) {
            const data = await this.$fetch('/api/proxy/web/tool/detail', { name })
            if (data && data.data) {
                if (name == 'noTraceSupplementSenior') this.pricePreMonth['senior'] = data.data
                if (name == 'noTraceSupplementOrdinary') this.pricePreMonth['ordinary'] = data.data
                if (name == 'noTraceSupplementOrdinary') this.pricePreMonth['batch'] = data.data
                if (name == 'tbitemsku') this.itemSkuPrice = data.data
            }
        },
        // 生成二维码
        qrcode(data) {
            if (this.$refs.qrcode) {
                this.$refs.qrcode.innerHTML = ''
            }

            let qrcode = new QRCode('qrcode', {
                width: 200,
                height: 200,
                text: data,
                // correctLevel: QRCode.CorrectLevel.M,
                correctLevel: 3,
                //容错级别，可设置为：(低到高)
                        // QRCode.CorrectLevel.L
                        // QRCode.CorrectLevel.M
                        // QRCode.CorrectLevel.Q
                        // QRCode.CorrectLevel.H
            })
            this.$refs.qrcode.removeAttribute('title')
            setTimeout(() => {
                this.$refs.qrcode.removeAttribute('title')
            }, 100);
        },
        setForm(obj) {
            for (const key in obj) {
                this.form[key] = obj[key]
            }
        },
        showOrdinaryTip() {
            this.$alert('免费版受淘宝频率限制，若无法正常获取二维码，请使用标签单高级版', '提示', {
                confirmButtonText: '确定',
                callback: action => {

                }
            });
        },
    },
    mounted() {
        this.priceLimit('noTraceSupplementSenior')
        this.priceLimit('noTraceSupplementOrdinary')
        this.priceLimit('tbitemsku')
        this.init()

    },
    watch: {
        activeMarking(newValue, oldValue) {
            if (newValue == 'ordinary') {
                this.form.tag = ''
                this.form.account = ''
            }
        }
    },
}
</script>

<style lang="scss" scoped>
.dialog_sku_tips {
    text-align: center;
    font-size: 1rem;
    font-weight: bold;
    margin-bottom: 1rem;
}

.custom_sku_tips {
    font-size: .8rem;
    color: #f56c6c;
}

.bg-none {
    background: none;
}

.font-bold {
    font-weight: bold;
}

.bg-none:hover {
    background: #F56C6C;
}

.comesoon {
    text-align: center;
    padding: 8rem 0 16rem;
    margin: 0 auto;
}

.traceless {
    .menu-type-img {
        width: 30px;
        height: 30px;
        margin-right: 6px;
    }
}

.batch-item-custom-sku {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 15px 0 15px 15px;

    .tip {
        color: #F56C6C;
        margin-right: 10px;        
    }
}

.batch-trace {
    .row-opt {
        margin-top: 5px;;
    }
}
</style>

<style lang="scss">
.traceless {
    .tip-card {
        margin-top: 0;
        .el-card__header {
            padding-bottom: 0;
        }
        .el-tabs__header {
            margin-bottom: 0;
        }
        .el-tabs__nav-wrap::after {
            height: 0;
        }
        .el-card__body {
            padding-top: 0;
            min-height: 500px;
        }
    }
}
</style>
